import Vue from 'vue';
import Router from 'vue-router';
import middleware from './middleware'; // eslint-disable-line
import Welcome from '@/views/Welcome.vue';
import Home from '@/views/Home.vue';
import Schedule from '@/views/Schedule.vue';

Vue.use(Router);

const cities = '/:city(amsterdam|toronto|san-francisco)';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
      props: {
        type: 'welcome',
      },
    },
    {
      path: cities,
      name: 'home',
      component: Home,
      props: {
        type: 'page',
      },
    },
    {
      path: `${cities}/speakers`,
      name: 'speakers',
      component: () => import(/* webpackChunkName: "speakers" */ '@/views/Speakers.vue'),
      props: {
        type: 'page',
      },
    },
    {
      path: `${cities}/speakers/:speaker`,
      name: 'speaker',
      component: () => import(/* webpackChunkName: "speaker" */ '@/views/Speaker.vue'),
      props: {
        type: 'child',
      },
    },
    {
      path: `${cities}/schedule`,
      name: 'schedule',
      component: Schedule,
      props: {
        type: 'page',
      },
    },
    {
      path: '/:city(toronto|san-francisco)/dev-sessions',
      name: 'dev-sessions',
      component: () => import(/* webpackChunkName: "workshops" */ '@/views/Dev.vue'),
      props: {
        type: 'page',
      },
    },
    {
      path: `${cities}/workshops`,
      name: 'workshops',
      component: () => import(/* webpackChunkName: "workshops" */ '@/views/Workshops.vue'),
      props: {
        type: 'page',
      },
    },
    {
      path: `${cities}/workshops/:workshop`,
      name: 'workshop',
      component: () => import(/* webpackChunkName: "workshop" */ '@/views/Workshop.vue'),
      props: {
        type: 'child',
      },
    },
    {
      path: `${cities}/activities`,
      name: 'activities',
      component: () => import(/* webpackChunkName: "activities" */ '@/views/Activities.vue'),
      props: {
        type: 'page',
      },
    },
    {
      path: `${cities}/venues`,
      name: 'venues',
      component: () => import(/* webpackChunkName: "venues" */ '@/views/Venues.vue'),
      props: {
        type: 'page',
      },
    },
  ],
});

middleware(router);

export default router;
